import { createBlueprint as e } from "@made-people/blueprint";
const t = e({
  slots: {
    wrapper: "flex gap-2 items-center relative",
    counter: "w-4 h-4 flex justify-center items-center rounded-full text-[10px] font-medium absolute top-1 right-1 bg-[#264F46] text-white empty:hidden",
    icon: "w-9 h-10 flex justify-center items-center [&>svg]:w-[16px] [&>svg]:h-[16px] [&>svg]:fill-inherit text-[--foreground] [&>svg]:fill-[--foreground]",
    label: ""
  },
  variants: {}
}), r = e({
  slots: {
    wrapper: "flex gap-0 items-center",
    icon: "w-9 h-10 flex justify-center items-center [&>svg]:w-[17px] text-[--foreground] [&>svg]:fill-[--foreground]",
    label: "text-body-sm"
  },
  variants: {}
}), i = e({
  slots: {
    wrapper: "flex gap-2 items-center",
    icon: "block w-9 h-10 flex justify-center items-center [&>svg]:w-[20px] [&>svg]:h-[13px]",
    label: ""
  },
  variants: {}
}), n = e({
  slots: {
    wrapper: "flex gap-2 items-center",
    icon: "block w-9 h-10 flex justify-center items-center [&>svg]:w-[16px] [&>svg]:h-[18px]",
    label: "",
    loggedInInitials: "size-8 text-heading-sm bg-neutral-100 text-black rounded-full"
  },
  variants: {}
}), o = e({
  slots: {
    wrapper: "flex justify-start items-center shrink-0 col-start-1 col-end-4 group/logo",
    link: "flex justify-start items-center w-full h-full active:translate-y-0.5 transition-transform [&>svg]:h-5 [&>svg]:fill-[--foreground]"
  },
  variants: {}
}), l = e({
  slots: {
    wrapper: "bg-neutral-100",
    nav: "flex gap-4 justify-between p-4",
    left: "w-1/3 flex justify-start items-center grow gap-4",
    search: "max-w-80 w-full",
    center: "flex z-10 justify-center w-32",
    logo: "",
    right: "w-1/3 flex justify-end items-center grow gap-4"
  },
  variants: {}
}), u = {
  main: l,
  menuTrigger: i.clone(),
  searchTrigger: r.clone(),
  accountTrigger: n.clone(),
  cartTrigger: t.clone(),
  logo: o.clone()
}, a = e({
  slots: {
    wrapper: "bg-neutral-100",
    nav: "flex gap-4 justify-between p-0 px-1",
    left: "w-1/3 flex justify-start items-center grow",
    center: "flex z-10 justify-center w-32",
    right: "w-1/3 flex justify-end items-center grow",
    siteSettingsTrigger: ""
  },
  variants: {}
}), f = {
  main: a,
  menuTrigger: i.clone(),
  searchTrigger: r.clone(),
  accountTrigger: n.clone(),
  cartTrigger: t.clone(),
  logo: o.clone()
}, s = e({
  slots: {
    wrapper: "bg-neutral-100 sticky top-0 z-10 bg-white",
    nav: "flex gap-4 justify-between p-0 px-3 h-12",
    left: "flex justify-start items-center",
    right: "flex justify-end items-center gap-1"
  },
  variants: {}
}), b = {
  main: s,
  menuTrigger: i.clone(),
  searchTrigger: r.clone(),
  accountTrigger: n.clone(),
  cartTrigger: t.clone(),
  logo: o.clone()
}, g = e({
  slots: {
    wrapper: "group transition-[height] duration-500 ease-[cubic-bezier(0.32,0.72,0,1)] w-full has-[.active-submenu]:hover:[--foreground:black] has-[.active-submenu]:hover:[--background:white] data-[scrolled=true]:shadow-[0_1px_0_0_rgba(0,0,0,0.05)]",
    nav: "relative justify-between h-full md:px-component-spacing-lg xl:px-component-spacing-2xl duration-300 lg:py-4 group-data-[scrolled=true]:lg:py-2 bg-[--background] grid grid-cols-12 gap-x-1",
    left: "justify-start items-center grid grid-cols-subgrid col-span-6",
    logo: "",
    right: "flex justify-end items-center gap-4 -mr-2.5 col-span-6",
    siteSettingsTrigger: "text-label-md text-[--foreground] flex gap-2 mr-2 font-normal"
  },
  variants: {
    color: {
      white: {
        wrapper: "[--foreground:black] [--background:white]"
      },
      transparent: {
        wrapper: "[--foreground:white] data-[scrolled=true]:[--background:white] before:absolute before:w-full before:h-[100%] before:transition-opacity before:bg-white/0 before:bg-gradient-to-b before:from-black/30 before:-z-20 data-[scrolled=true]:before:bg-none data-[scrolled=true]:before:hidden data-[scrolled=true]:[--foreground:black]"
      }
    }
  }
}), m = {
  main: g,
  searchTrigger: r.clone(),
  accountTrigger: n.clone(),
  cartTrigger: t.clone(),
  logo: o.clone()
}, c = e({
  slots: {
    wrapper: "bg-white",
    nav: "",
    menuPosition: "",
    logoPosition: "",
    cartTriggerPosition: "",
    accountTriggerPosition: "",
    siteSettingsTriggerPosition: "",
    searchTriggerPosition: "",
    topbarPosition: ""
  },
  variants: {
    color: {
      white: { wrapper: "" },
      transparent: { wrapper: "" }
    }
  }
}), d = {
  main: c,
  searchTrigger: r.clone(),
  accountTrigger: n.clone(),
  cartTrigger: t.clone(),
  logo: o.clone()
};
export {
  n as accountTriggerBlueprint,
  d as bareboneBlueprint,
  t as cartTriggerBlueprint,
  o as logoBlueprint,
  i as menuTriggerBlueprint,
  r as searchTriggerBlueprint,
  u as template1Styling,
  f as template2Styling,
  b as template3Styling,
  m as template4Styling
};
//# sourceMappingURL=index-blueprint.es.js.map
